import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import { connect } from 'react-redux'
import { container, infoColor } from '../../../assets/material-kit-react'
// import Card from "../../../components/Card/Card";
import GridContainer from '../../../components/grid/GridContainer'
import GridItem from '../../../components/grid/GridItem'
import CustomInput from '../../../components/CustomInput'
import Button from '../../../components/Button';
import Title from '../../../components/typography/Title'
import Label from '../../../components/typography/Label'
import { 
    changeName,
    changePhoneNumber,
    changeAge,
    changeGender,
    changeMaritalStatus,
    changeBudget,
    changeUnitType,
    changeMessage,
    submitContact,
    closeInformationDialog
} from '../../../actions/ContactUsAction'
import InformationDialog from '../../../components/InformationDialog'
import customCheckboxRadioSwitch from '../../../assets/component/customCheckboxRadioSwitch'
import * as Sentry from '@sentry/browser'
//import { withLocalize, Translate } from 'react-localize-redux';

Sentry.init({
    dsn: "https://a2a837fdcc7047ee8369a55e2f144948@sentry.io/1337446"
   });

class ContactUs extends Component {

    componentDidCatch(error, errorInfo) {

        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => {
              scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
          });
          
    }


    render(){
        
        const { classes, contact_us }  = this.props

        // console.log('---- contact us -----')
        // console.log(contact_us)
        // console.log("prop", this.props)
        // console.log('---- contact us -----')

        return (
            <div className={classes.sections}>

                {/* <Card> */}
                    <div className={classes.container}> 

                        <GridContainer>

                            <GridItem xs={12} sm={12} md={6} className={classes.topHolder}>

                                <h3 className={classes.title}>
                                    Contact Us
                                </h3>
                                
                                <CustomInput
                                    labelText="Name"
                                    id="float"
                                    formControlProps={{
                                        fullWidth: true,
                                        color: infoColor
                                    }}
                                    inputProps={{
                                        value: contact_us.name,
                                        onChange: this.handleChangeName
                                    }}
                                />

                                <CustomInput
                                    labelText="Phone Number"
                                    id="float"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        value: contact_us.phone_number,
                                        onChange: this.handleChangePhoneNumber
                                    }}
                                />

                                <GridContainer className={classes.content_margin}>

                                    <GridItem xs={12} sm={12} md={4}>
                                        <Title>Age</Title>

                                            <FormControlLabel
                                                control={
                                                <Radio
                                                    checked={contact_us.age === "20 - 30"}
                                                    onChange={this.handleAge}
                                                    value="20 - 30"
                                                    name="radio button enabled"
                                                    aria-label="20-30"
                                                    icon={
                                                    <FiberManualRecord
                                                        className={classes.radioUnchecked}
                                                    />
                                                    }
                                                    checkedIcon={
                                                    <FiberManualRecord className={classes.radioChecked} />
                                                    }
                                                    classes={{
                                                    checked: classes.radio
                                                    }}
                                                />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="20 - 30"
                                            />

                                            <FormControlLabel
                                                control={
                                                <Radio
                                                    checked={contact_us.age === "31 - 40"}
                                                    onChange={this.handleAge}
                                                    value="31 - 40"
                                                    name="radio button enabled"
                                                    aria-label="31-40"
                                                    icon={
                                                    <FiberManualRecord
                                                        className={classes.radioUnchecked}
                                                    />
                                                    }
                                                    checkedIcon={
                                                    <FiberManualRecord className={classes.radioChecked} />
                                                    }
                                                    classes={{
                                                    checked: classes.radio
                                                    }}
                                                />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="31 - 40"
                                            />

                                            <FormControlLabel
                                                control={
                                                <Radio
                                                    checked={contact_us.age === "41 - Above"}
                                                    onChange={this.handleAge}
                                                    value="41 - Above"
                                                    name="radio button enabled"
                                                    aria-label="41 - Above"
                                                    icon={
                                                    <FiberManualRecord
                                                        className={classes.radioUnchecked}
                                                    />
                                                    }
                                                    checkedIcon={
                                                    <FiberManualRecord className={classes.radioChecked} />
                                                    }
                                                    classes={{
                                                    checked: classes.radio
                                                    }}
                                                />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="41 - Above"
                                            />

                                    </GridItem>

                                    <GridItem  xs={12} sm={12} md={4}>
                                        <Title>Gender</Title>

                                                <FormControlLabel
                                                    control={
                                                    <Radio
                                                        checked={contact_us.gender === "Male"}
                                                        onChange={this.handleGender}
                                                        value="Male"
                                                        name="Male"
                                                        aria-label="Male"
                                                        icon={
                                                        <FiberManualRecord
                                                            className={classes.radioUnchecked}
                                                        />
                                                        }
                                                        checkedIcon={
                                                            <FiberManualRecord className={classes.radioChecked} />
                                                        }
                                                        classes={{
                                                            checked: classes.radio
                                                        }}
                                                    />
                                                    }
                                                    classes={{
                                                    label: classes.label
                                                    }}
                                                    label="Male"
                                                />

                                                <FormControlLabel
                                                    control={
                                                    <Radio
                                                        checked={contact_us.gender === "Female"}
                                                        onChange={this.handleGender}
                                                        value="Female"
                                                        name="radio button enabled"
                                                        aria-label="Female"
                                                        icon={
                                                        <FiberManualRecord
                                                            className={classes.radioUnchecked}
                                                        />
                                                        }
                                                        checkedIcon={
                                                        <FiberManualRecord className={classes.radioChecked} />
                                                        }
                                                        classes={{
                                                        checked: classes.radio
                                                        }}
                                                    />
                                                    }
                                                    classes={{
                                                    label: classes.label
                                                    }}
                                                    label="Female"
                                                />
                                           
                                    </GridItem>

                                    <GridItem xs={12} sm={12} md={4}>

                                        <Title>Marital Status</Title>

                                        <FormControlLabel
                                                control={
                                                <Radio
                                                    checked={contact_us.marital_status === "Single"}
                                                    onChange={this.handleMaritalStatus}
                                                    value="Single"
                                                    name="radio button enabled"
                                                    aria-label="Single"
                                                    icon={
                                                    <FiberManualRecord
                                                        className={classes.radioUnchecked}
                                                    />
                                                    }
                                                    checkedIcon={
                                                    <FiberManualRecord className={classes.radioChecked} />
                                                    }
                                                    classes={{
                                                    checked: classes.radio
                                                    }}
                                                />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="Single"
                                            />

                                            <FormControlLabel
                                                control={
                                                <Radio
                                                    checked={contact_us.marital_status === "Married"}
                                                    onChange={this.handleMaritalStatus}
                                                    value="Married"
                                                    name="radio button enabled"
                                                    aria-label="Married"
                                                    icon={
                                                    <FiberManualRecord
                                                        className={classes.radioUnchecked}
                                                    />
                                                    }
                                                    checkedIcon={
                                                    <FiberManualRecord className={classes.radioChecked} />
                                                    }
                                                    classes={{
                                                    checked: classes.radio
                                                    }}
                                                />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="Married"
                                            />

                                    </GridItem>

                                </GridContainer>
                                
                             </GridItem>

                             <GridItem xs={12} sm={12} md={6}>

                                <GridContainer>

                                    <GridItem className={classes.content_margin} xs={12} sm={12} md={12}>

                                        <Title>Budget for Housing</Title>
                                        <div className={classes.radio_btn_holder}>

                                            <FormControlLabel
                                                control={
                                                <Radio
                                                    checked={contact_us.budget === "<500Lakhs"}
                                                    onChange={this.handleBudget}
                                                    value="<500Lakhs"
                                                    name="radio button enabled"
                                                    aria-label="A"
                                                    icon={
                                                    <FiberManualRecord
                                                        className={classes.radioUnchecked}
                                                    />
                                                    }
                                                    checkedIcon={
                                                    <FiberManualRecord className={classes.radioChecked} />
                                                    }
                                                    classes={{
                                                    checked: classes.radio
                                                    }}
                                                />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="< 500 Lakhs"
                                            />

                                            <FormControlLabel
                                                control={
                                                <Radio
                                                    checked={contact_us.budget === "500-700Lakhs"}
                                                    onChange={this.handleBudget}
                                                    value="500-700Lakhs"
                                                    name="radio button enabled"
                                                    aria-label="A"
                                                    icon={
                                                    <FiberManualRecord
                                                        className={classes.radioUnchecked}
                                                    />
                                                    }
                                                    checkedIcon={
                                                    <FiberManualRecord className={classes.radioChecked} />
                                                    }
                                                    classes={{
                                                    checked: classes.radio
                                                    }}
                                                />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="500-700 Lakhs"
                                            />

                                            <FormControlLabel
                                                control={
                                                <Radio
                                                    checked={contact_us.budget === "700-900Lakhs"}
                                                    onChange={this.handleBudget}
                                                    value="700-900Lakhs"
                                                    name="radio button enabled"
                                                    aria-label="700-900Lakhs"
                                                    icon={
                                                    <FiberManualRecord
                                                        className={classes.radioUnchecked}
                                                    />
                                                    }
                                                    checkedIcon={
                                                    <FiberManualRecord className={classes.radioChecked} />
                                                    }
                                                    classes={{
                                                    checked: classes.radio
                                                    }}
                                                />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="700-900 Lakhs"
                                            />

                                            <FormControlLabel
                                                control={
                                                <Radio
                                                    checked={contact_us.budget === "900-1200Lakhs"}
                                                    onChange={this.handleBudget}
                                                    value="900-1200Lakhs"
                                                    name="radio button enabled"
                                                    aria-label="900-1200 Lakhs"
                                                    icon={
                                                    <FiberManualRecord
                                                        className={classes.radioUnchecked}
                                                    />
                                                    }
                                                    checkedIcon={
                                                    <FiberManualRecord className={classes.radioChecked} />
                                                    }
                                                    classes={{
                                                    checked: classes.radio
                                                    }}
                                                />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="900-1200 Lakhs"
                                            />

                                            <FormControlLabel
                                                control={
                                                <Radio
                                                    checked={contact_us.budget === ">1200Lakhs"}
                                                    onChange={this.handleBudget}
                                                    value=">1200Lakhs"
                                                    name="radio button enabled"
                                                    aria-label="> 1200 Lakh"
                                                    icon={
                                                    <FiberManualRecord
                                                        className={classes.radioUnchecked}
                                                    />
                                                    }
                                                    checkedIcon={
                                                    <FiberManualRecord className={classes.radioChecked} />
                                                    }
                                                    classes={{
                                                    checked: classes.radio
                                                    }}
                                                />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="> 1200 Lakhs"
                                            />
                                        </div>
                                    </GridItem>

                                    <GridItem className={classes.content_margin} xs={12} sm={12} md={12}>

                                        <Title>Unit Type to Enquire</Title>
                                        <div className={classes.radio_btn_holder}>

                                            <FormControlLabel
                                                control={
                                                    <Radio
                                                        checked={contact_us.unit_type === "Studio"}
                                                        onChange={this.handleUnitType}
                                                        value="Studio"
                                                        name="radio button enabled"
                                                        aria-label="Studio"
                                                        icon={
                                                        <FiberManualRecord
                                                            className={classes.radioUnchecked}
                                                        />
                                                        }
                                                        checkedIcon={
                                                        <FiberManualRecord className={classes.radioChecked} />
                                                        }
                                                        classes={{
                                                        checked: classes.radio
                                                        }}
                                                    />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="Studio"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Radio
                                                        checked={contact_us.unit_type === "1 Bed Room"}
                                                        onChange={this.handleUnitType}
                                                        value="1 Bed Room"
                                                        name="radio button enabled"
                                                        aria-label="A"
                                                        icon={
                                                        <FiberManualRecord
                                                            className={classes.radioUnchecked}
                                                        />
                                                        }
                                                        checkedIcon={
                                                        <FiberManualRecord className={classes.radioChecked} />
                                                        }
                                                        classes={{
                                                        checked: classes.radio
                                                        }}
                                                    />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="1 Bed Room"
                                            />

                                            <FormControlLabel
                                                control={
                                                <Radio
                                                    checked={contact_us.unit_type === "2 Bed Room"}
                                                    onChange={this.handleUnitType}
                                                    value="2 Bed Room"
                                                    name="radio button enabled"
                                                    aria-label="2 Bed Room"
                                                    icon={
                                                    <FiberManualRecord
                                                        className={classes.radioUnchecked}
                                                    />
                                                    }
                                                    checkedIcon={
                                                    <FiberManualRecord className={classes.radioChecked} />
                                                    }
                                                    classes={{
                                                    checked: classes.radio
                                                    }}
                                                />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="2 Bed Room"
                                            />

                                            <FormControlLabel
                                                control={
                                                <Radio
                                                    checked={contact_us.unit_type === "3 Bed Room"}
                                                    onChange={this.handleUnitType}
                                                    value="3 Bed Room"
                                                    name="radio button enabled"
                                                    aria-label="3 Bed Room"
                                                    icon={
                                                    <FiberManualRecord
                                                        className={classes.radioUnchecked}
                                                    />
                                                    }
                                                    checkedIcon={
                                                    <FiberManualRecord className={classes.radioChecked} />
                                                    }
                                                    classes={{
                                                    checked: classes.radio
                                                    }}
                                                />
                                                }
                                                classes={{
                                                label: classes.label
                                                }}
                                                label="3 Bed Room"
                                            />
                                        </div>
                                    </GridItem>
                                    
                                    <GridItem className={classes.content_margin} xs={12} sm={12} md={12}>
                                        
                                        <Title>Message</Title>

                                            <CustomInput
                                                labelText="Write Something"
                                                id="float"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    value: contact_us.message,
                                                    multiline: true,
                                                    onChange: this.handleChangeMessage
                                                }}
                                            />
                                    </GridItem>

                                </GridContainer>

                                <div className={classes.buttonContainer}>
                                    <Button 
                                        className ={classes.submitButton}
                                        disabled = {!this.getSubmitButtonState()}
                                        color="info"
                                        onClick={ this.handelSubmit }
                                    >
                                        Submit
                                    </Button>
                                </div>

                                <div className={classes.contact_info}>

                                    <Title>
                                        Please do not hesitate to contact us for more information.
                                    </Title>

                                    <div className={classes.contact}>
                                        <Label>
                                            HotLine: <Title>09 777 223 355, 09 777 223 366, 09777 223 377</Title>
                                        </Label>
                                    </div>

                                    <div className={classes.contact}>
                                        <Label>
                                            Email: <Title><a href="mailto:cityloftsales@yomaland.com">cityloftsales@yomaland.com</a></Title>
                                        </Label>
                                    </div>

                                    <div className={classes.contact}>
                                        <Label>
                                            Address: <Title> City Loft Sales Gallery @ StarCity Yangon, Kyaik Khauk Pagoda Road,Thanlyin Township, Yangon. Myanmar. </Title>
                                        </Label>
                                    </div>

                                </div> 
                                   
                                 {/* <Card className={classes.card}>
                                        <img className = {classes.image} src={require('../../../images/girl.png')} alt={"SaleGirl"}/>
                                </Card> */}

                             </GridItem>
                        
                        </GridContainer>

                        <InformationDialog
                            open= {contact_us.success}
                            handleClose = {this.handleCloseDailog}
                        />

                    </div>
                    
                    <footer>
                        <img src={require('../../../images/CityLoftFrame.svg')} alt="Frame"/>
                    </footer>

                {/* </Card> */}

            </div>
        )
    }


    getSubmitButtonState(){

        const {contact_us} = this.props

        return contact_us.name.length > 0 && contact_us.phone_number.length > 0 
    }

    handleChangeName = (event) => {

        this.props.changeName(event.target.value)
    }

    handleChangePhoneNumber = (event) => {
        this.props.changePhoneNumber(event.target.value)
    }

    handleAge = (event) => {
        this.props.changeAge(event.target.value)
    }

    handleGender = (event) => {
        this.props.changeGender(event.target.value)
    }

    handleMaritalStatus= (event) => {
        this.props.changeMaritalStatus(event.target.value)
    }

    handleBudget= (event) => {
        this.props.changeBudget(event.target.value)
    }

    handleUnitType= (event) => {
        this.props.changeUnitType(event.target.value)
    }

    handleChangeMessage = (event) => {
        this.props.changeMessage(event.target.value)
    }

    handelSubmit = () => {
        
       this.props.submitContact({contact_us: this.props.contact_us, param: this.props.param})

    }

    handleCloseDailog = () => {

        this.props.closeInformationDialog(false)

    }


}

const styles = theme => ({
    sections: {
        flex: 1,
        minHeight: '100vh',
        
    },
    container: {
        ...container,
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '20px',
        paddingBottom: '50px'
    },
    card: {
        background: "#3f8f9b",
    },
    title: {
        fontSize: "2.0rem",
        fontWeight: "600",
        position: "relative",
        display: "inline",
        fontFamily: '"Poppins"',
        color: infoColor
    },
    contact_info: {
        marginTop: "40px",
        paddingLeft: "30px"
    },
    contact: {
        marginTop: "15px"
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    submitButton: {
        width: 150
    },
    image: {
        paddingTop: "40px",
        paddingLeft:"40px",
        paddingRight: "40px",
        height: "500px"
    },
    ...customCheckboxRadioSwitch,
    radio_btn_holder: {
        display: "flex",
        flex: 1,
        flexDirection: "row",
        flexWrap: "wrap"
    },
    main_holder_margin: {
        marginTop: "75px",
        paddingLeft: "30px"
    },
    content_margin: {
        marginTop: "20px"
    },
    topHolder: {
      //  marginLeft: "20px"
    }
    
})

ContactUs.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
    
    return {
        contact_us: state.ContactUsReducer
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        changeName: (text) => {
            dispatch(changeName(text))
        },
        changePhoneNumber: (text) => {
            dispatch(changePhoneNumber(text))
        },
        changeAge: (text) => {
            dispatch(changeAge(text))
        },
        changeGender: (text) => {
            dispatch(changeGender(text))
        },
        changeMaritalStatus: (text) => {
            dispatch(changeMaritalStatus(text))
        },
        changeBudget: (text) => {
            dispatch(changeBudget(text))
        },
        changeUnitType: (text) => {
            dispatch(changeUnitType(text))
        },
        changeMessage: (text) => {
            dispatch(changeMessage(text))
        },
        submitContact: (props) => {
            dispatch(submitContact(props))
        },
        closeInformationDialog: (close) => {
            dispatch(closeInformationDialog(close))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ContactUs))
